// extracted by mini-css-extract-plugin
var _1 = "ra-xmas";
var _2 = "ra-xmas-content";
var _3 = "ra-xmas-content-main";
var _4 = "ra-xmas-icon";
export { _1 as "xmaxCls", _2 as "xmaxContentCls", _3 as "xmaxContentMainCls", _4 as "xmaxIconCls" }
